export default __webpack_public_path__ + "static/aus-nov-gain-4a747195607230664d0c06997cdfcb89.jpg";